import { Action } from '@ngrx/store';
import { label } from '../util';
import { IRetrieveCheckinStatusRequestPayload } from '../models/action-payloads/retrieve-checkin-status-payload';
import { PhotoListResponse } from '../models';

export const GuestActionTypes = {
	LOAD_GUESTS_PROFILE_BOOKING_MICROSERVICE: label('[OLC] Get Guest Information Microservice'),
	UPDATE_GUESTS_FNAME: label('[OLC] Update Personal Detail Success'),
	SELECT_GUESTID_BOOKINGID: label('[OLC]    SelectGuestIdBookingIdAction '),
	RESET_SELECTED_OTHER_GUEST: label('[OLC] RESET SELECTED OTHER GUEST'),
	POST_SURVEY: label('[OLC] Post Survey'),
	POST_SURVEY_SUCCESS: label('[OLC] Post Survey Success'),
	RESET_GUESTS_SELECTED_FOR_CHECKIN: label('[OLC] Reset Guests Selected For Checkin Process'),
	SELECT_GUEST_FOR_EDIT: label('[OLC]    SELECT GUEST FOR EDIT'),
	UPDATE_GUESTS_TO_CHECKIN_VM: label('[OLC] Update Guest Selected For Checkin Process'),
	RETRIEVE_GUEST_SECURITY_PHOTO_LIST: label('[OLC] Retrieve guests security photo list'),
	RETRIEVE_GUEST_SECURITY_PHOTO_LIST_SUCCESS: label('[OLC] Retrieve guests security photo list Success'),
	SAVE_GUEST_PHOTO: label('[OLC] Save Guest Photo'),
	UPDATE_GUEST_PHOTO: label('[OLC] Update Guest Photo'),
	UPDATE_GUEST_PHOTO_SUCCESS: label('[OLC] Update Guest Photo Success'),
	SAVE_GUEST_PHOTO_SUCCESS: label('[OLC] Save Guest Photo Success'),
	UPDATE_PROGRESS_LOADED: label('[OLC] Update Progress loaded'),
	GET_PERCENTAGE_COMPLETION: label('[OLC] Get Percentage Completion'),
	UPDATE_COMPLETION_PERCENTAGE_GUEST: label('[OLC] Update Completion Percentage Guest'),
	LOAD_PDETAIL: label('[OLC] Load Personal Detail'),
	UPDATE_SELECTED_GUEST: label('[OLC] Update Selected Guest'),
	CLEAR_SELECTED_GUEST: label('[OLC] Clear Selected Guest'),
	CLEAR_GUESTS_LIST: label('[OLC] Clear Guests List'),
	DELETE_GUEST_PHOTO: label('[OLC] Delete Guest Photo'),
	DELETE_GUEST_PHOTO_SUCCESS: label('[OLC] Delete Guest Photo Success'),
	UPDATE_GUESTS_INFO: label('[OLC] Update Guests Info')
};

export class LoadGuestsProfileBookingMicroserviceAction implements Action {
	type = GuestActionTypes.LOAD_GUESTS_PROFILE_BOOKING_MICROSERVICE;
	constructor(public payload: any) {}
}

// Personal Detail page actions
export class UpdateGuestFirstNameAction implements Action {
	type = GuestActionTypes.UPDATE_GUESTS_FNAME;
	constructor(public payload: any) {}
}

export class SelectGuestIdBookingIdAction implements Action {
	type = GuestActionTypes.SELECT_GUESTID_BOOKINGID;
	constructor(public payload: any) {}
}

export class ResetSelectedOtherGuest implements Action {
	type = GuestActionTypes.RESET_SELECTED_OTHER_GUEST;
}

export class PostSurveyAction implements Action {
	type = GuestActionTypes.POST_SURVEY;
	constructor(public payload: any) {}
}

export class ResetGuestsSelectedForCheckinAction implements Action {
	type = GuestActionTypes.RESET_GUESTS_SELECTED_FOR_CHECKIN;
	constructor(public payload: any) {}
}

export class SelectGuestForEditAction implements Action {
	type = GuestActionTypes.SELECT_GUEST_FOR_EDIT;
	constructor(public payload: any) {}
}

export class UpdateGuestToAddVM implements Action {
	type = GuestActionTypes.UPDATE_GUESTS_TO_CHECKIN_VM;
	constructor(public payload: any) {}
}

export class RetrieveGuestSecurityPhotoListAction implements Action {
	type = GuestActionTypes.RETRIEVE_GUEST_SECURITY_PHOTO_LIST;
	constructor(public payload: object) {}
}

export class RetrieveGuestSecurityPhotoListSuccessAction implements Action {
	type = GuestActionTypes.RETRIEVE_GUEST_SECURITY_PHOTO_LIST_SUCCESS;
	constructor(public payload: PhotoListResponse) {}
}

export class SaveGuestPhotoAction implements Action {
	type = GuestActionTypes.SAVE_GUEST_PHOTO;
	constructor(public payload: object) {}
}

export class UpdateGuestPhotoAction implements Action {
	type = GuestActionTypes.UPDATE_GUEST_PHOTO;
	constructor(public payload: object) {}
}

export class UpdateGuestPhotoSuccessAction implements Action {
	type = GuestActionTypes.UPDATE_GUEST_PHOTO_SUCCESS;
	constructor(public payload: object) {}
}

export class SaveGuestPhotoSuccessAction implements Action {
	type = GuestActionTypes.SAVE_GUEST_PHOTO_SUCCESS;
	constructor(public payload: object) {}
}

export class UpdateProgressLoadedAction implements Action {
	type = GuestActionTypes.UPDATE_PROGRESS_LOADED;
	constructor(public payload: boolean) {}
}

export class GetPercentageCompletionAction implements Action {
	type = GuestActionTypes.GET_PERCENTAGE_COMPLETION;
	constructor(public payload: IRetrieveCheckinStatusRequestPayload) {}
}

export class UpdateCompletionPercentageGuestAction implements Action {
	type = GuestActionTypes.UPDATE_COMPLETION_PERCENTAGE_GUEST;
	constructor(public payload: any) {}
}

export class LoadPdetailAction implements Action {
	type = GuestActionTypes.LOAD_PDETAIL;
	constructor(public payload: number) {}
}

export class UpdateSelectedGuestAction implements Action {
	type = GuestActionTypes.UPDATE_SELECTED_GUEST;
	constructor(public payload: any) {}
}

export class ClearSelectedGuestAction implements Action {
	type = GuestActionTypes.CLEAR_SELECTED_GUEST;
}

export class ClearGuestsList implements Action {
	type = GuestActionTypes.CLEAR_GUESTS_LIST;
}

export class DeleteGuestPhotoAction implements Action {
	type = GuestActionTypes.DELETE_GUEST_PHOTO;
	constructor(public payload: object) {}
}

export class DeleteGuestPhotoSuccessAction implements Action {
	type = GuestActionTypes.DELETE_GUEST_PHOTO_SUCCESS;
	constructor(public payload: object) {}
}

export class UpdateGuestsInfoFromBeginMicroservice implements Action {
	type = GuestActionTypes.UPDATE_GUESTS_INFO;
	constructor(public payload: any) {}
}
